import { Outlet, type RouteObject } from 'react-router-dom';
import { RequireAuth } from '@/auth/RequireAuth';
import type { RouteHandle } from '@/layout/routeHandle';
import { MASTER_KINDS, MasterIndexPage, MasterKindPage } from './MasterPages';

/**
 * マスタ管理（S-92。基金のみ）。パスは `/years/:year` からの相対。
 * 共通選択部品（BusinessOperatorSelect / VesselSelect / PortSelect）は components/、公開 API は index.ts。
 */
export const routes: RouteObject[] = [
  {
    path: 'admin/masters',
    handle: { crumb: 'マスタ管理' } satisfies RouteHandle,
    element: (
      <RequireAuth roles={['基金']}>
        <Outlet />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <MasterIndexPage /> },
      { path: ':kind', element: <MasterKindPage />, handle: { crumb: (p) => MASTER_KINDS.find((k) => k.key === p.kind)?.title ?? p.kind ?? '' } satisfies RouteHandle },
    ],
  },
];
